import * as React from 'react';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ListViewModelImpl } from '../../../../toolkit/horizontallist/listviewmodel';
import { DedicateFlashDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { DedicateFlashCardMessageComponent } from './dedicatecard/dedicateflashcardmessagecomponent';


export class DedicateFlashMessageToneViewModelImpl extends ListViewModelImpl<DedicateFlashDto>
{
    constructor(context: BaseContext, private onDeleteClicked: any)
    {
        super(context);

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
    }

    getOffset(): number
    {
        return 5;
    }

    getView(t: DedicateFlashDto, position: number): boolean | JSX.Element 
    {
       return <DedicateFlashCardMessageComponent onDeleteDedicateClicked={this.onDeleteClicked} flashDto={t} context={this.getContext()}/>;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicateflashmessageviewmodel.tsx